import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { RefreshProcessService } from 'app/core/services/refresh-process/refresh-process.service';

@Component({
  selector: 'dialog-delete-process',
  templateUrl: './dialog-delete-process.component.html',
  styleUrls: ['./dialog-delete-process.component.scss']
})
export class DialogDeleteProcessComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteProcessComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private processSchedulerService: ProcessSchedulerService, private refreshProcess: RefreshProcessService) { }

  ngOnInit(): void {
    console.log(this.data.id);
    console.log(this.data.type)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteProcess() {
    this.isLoading = true;
    const process = {
      id: this.data.id,
      type: this.data.type
    }
    this.processSchedulerService.delete_process(process).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshProcess.emitRefresh(res);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
